import { render, staticRenderFns } from "./QuesRouter.vue?vue&type=template&id=d8ae07d6&scoped=true&"
import script from "./QuesRouter.vue?vue&type=script&lang=js&"
export * from "./QuesRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ae07d6",
  null
  
)

export default component.exports